import Env from 'root/lib/Env';
import MEASURE_IDS from 'a/placementTool/data/measureIds';
import gameIds from '../hub/data/GameIds';

export const MEASURE_ID = MEASURE_IDS.BLENDING;
export const GAME_ID = gameIds.BLENDING;

export const SHARED_CONTENT_URL = `${Env.GAME_CONTENT_URL}/measure.blending`;
export const CURRICULUM_URL = `${Env.GAME_CONTENT_URL}/measure.blending/curriculum/`;
export const WORDS_URL = `${SHARED_CONTENT_URL}/audio/words/spa-es-default`;
export const QUESTIONS_PER_LEVEL = 6;

export const SCREENS = {
  LOADING: 'measure.blending: loading',
  ONBOARDING: 'measure.blending: onboarding',
  STANDARD: 'measure.blending: standard',
};

export const THEME = {
  LIGHT_TEAL: '#EBF4FA',
  TEAL: '#83C5F1',
  WHITE: '#F5F5F5',
  BLACK: '#000000',
};

export const AVATAR_STATES = {
  IDLE: 'IDLE',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  INSTRUCTING: 'INSTRUCTING',
  SPEAKING: 'SPEAKING',
  ENCOURAGING: 'ENCOURAGING',
};

export const CURRICULUM_TYPES = {
  SYLLABLE: 'syllable',
  PHONEME: 'phoneme',
};

export const ROUND_TYPES = {
  SYLLABLE: 'Syllables',
  PHONEME: 'Phonemes',
};

export const STIMULUS_TYPES = {
  SYLLABLE: 'Blend syllables into CVCV word',
  PHONEME: 'Blend phonemes into CVC word',
};

export const REDUX_ACTIONS = {
  SET_QUESTION_INDEX: 'SET_QUESTION_INDEX',
  SET_RESPONSES: 'SET_RESPONSES',
};

export const MAIN_SCREEN_TEXT = 'Haz clic en el dibujo de la palabra que escuchas.';
